// Whether this customer's survey tables show Dip or Inclination.
//
// Mirrors Services/SurveyExportRender.PrefersDip. Kept in one place because the
// fallback is the subtle part: the tables used to switch on
// `industry === 'mining'` directly, and six customers hold survey data with no
// industry set at all, so they read as Inclination today. An explicit preference
// wins; unset must keep behaving exactly as before, or those customers silently
// change convention.
//
// This is a *display* choice only. What an exported column contains is decided
// by which column the export template selects.

export const DIP = 'Dip';
export const INCLINATION = 'Inclination';

export function prefersDip(angleDisplay, industry) {
    if (angleDisplay) {
        return String(angleDisplay).toLowerCase() === DIP.toLowerCase();
    }
    return !!industry && String(industry).toLowerCase() === 'mining';
}

/** The column heading to show above the angle. */
export function angleHeader(angleDisplay, industry) {
    return prefersDip(angleDisplay, industry) ? DIP : INCLINATION;
}

/** The value to show under it, given a shot's measured inclination. */
export function angleValue(inclination, angleDisplay, industry) {
    if (typeof inclination !== 'number' || isNaN(inclination)) return null;
    return prefersDip(angleDisplay, industry) ? inclination - 90 : inclination;
}
